import React, { useEffect, useState } from "react";
// import Sidebar from "../components/sidebar/Sidebar";
// import Navbar from "../components/navbar/Navbar";
import { Box, Stack } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../navbar/Navbar";
import useAuth from "../../hooks/useAuth";
import { printDebugLog } from "../../constants/Constants";

const DashBoardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    printDebugLog("DashBoardLayout: ", isLoggedIn);
  }, [isLoggedIn])

  return (
    <div style={{ width: "100%" }}>
      {!isLoggedIn && <Navigate replace to="/login" />}
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      <Stack
        flex={1}
        ml={isSidebarOpen ? { md: "330px", xs: 0 } : { md: "70px", xs: 0 }}
        overflow="hidden"
      >
        <Navbar setIsSidebarOpen={setIsSidebarOpen} />
        <Box sx={{ m: 1 }} >
          <Outlet />
        </Box>
      </Stack>
    </div>
  );
};

export default DashBoardLayout;
